import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

import Button from "@/components/wpl/button/src";
import { useLocalizedHref } from "@/libraries/web-framework";
import { DataEventProps } from "@/libraries/wpl/foundations/src";

const h2Style = css({
    "fontWeight": 500,
    "textAlign": "center",
    "color": "#FFFFFF",
    "margin": 0,
    "@media (max-width: 47.99rem)": {
        fontSize: "2rem",
        lineHeight: "2.375rem"
    },
    "@media (min-width: 48rem) and (max-width: 63.99rem)": {
        fontSize: "2.25rem",
        lineHeight: "2.625rem"
    },
    "@media (min-width: 64rem)": {
        fontSize: "2.5rem",
        lineHeight: "3rem"
    }
});

const buttonContainer = css({
    padding: "16px"
});

const CtaSection = () => {
    const intl = useIntl();

    const linkText = intl.formatMessage({
        id: "ConfluenceSoftwarePageTemplate.ctaSection.button",
        defaultMessage: "Get it free"
    });

    const buttonDataEventProps: DataEventProps = {
        "data-product-key": "confluence",
        "data-event-component": "linkButton",
        "data-event-container": "ctaSection",
        "data-event": "clicked",
        "data-label": linkText,
        "data-label-english": "Get it free"
    };

    return (
        <section
            css={css({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                backgroundColor: "#4c9aff",
                padding: `${token("space.400")} ${token("space.200")}`,
                [media.above.sm]: {
                    padding: `${token("space.1000")} 0`
                },
                [media.above.md]: {
                    backgroundImage:
                        "url(https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:515850bc-bda7-4aa4-ad46-88ea178920c0/CTA_Graphic_Left.svg?cdnVersion=1267), url(https://wac-cdn-2.atlassian.com/image/upload/f_auto,q_auto/dam/jcr:c72a51b6-9afc-40e4-a9ad-7179bfc03fde/CTA_Graphic_Right.svg?cdnVersion=1267)",
                    backgroundPosition: "center left, center right",
                    backgroundRepeat: "no-repeat, no-repeat",
                    backgroundSize: "auto 243px, auto 243px"
                }
            })}
        >
            <h2 css={h2Style}>
                {intl.formatMessage({
                    id: "ConfluenceSoftwarePageTemplate.ctaSection.trying.header",
                    defaultMessage: "Trying Confluence is easy — and free"
                })}
            </h2>
            <div css={buttonContainer}>
                <Button
                    color="yellow"
                    type="primary"
                    size="large"
                    url={useLocalizedHref(
                        "/try/cloud/signup?bundle=confluence&edition=free"
                    )}
                    text={linkText}
                    dataEventProps={buttonDataEventProps}
                />
            </div>
        </section>
    );
};

export default CtaSection;
